/*
 * Copyright (c) 2020. Sayari LLC
 */

import {Component} from '@angular/core';
import {LoginUser} from '../models/login.user';
import {NgForm} from '@angular/forms';
import {LoginService} from './login.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent {
    loginUser: LoginUser = new LoginUser();
    authSuccess = true;
    authErrorMsg = 'Invalid username/password';
    constructor(private loginService: LoginService){}

    onSubmit(loginForm: NgForm) {
        this.loginUser.username = loginForm.value.username;
        this.loginUser.password = loginForm.value.password;
        this.authSuccess = this.loginService.login(this.loginUser);
    }
}
